export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";